module.exports = __webpack_public_path__ + "img/client-10.5c982934.png";